import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from '@components/App/App';
import { BrowserRouter as Router } from "react-router-dom";
import Auth0ProviderWithHistory from "@auth/Auth0ProviderWithHistory";

ReactDOM.render(
  <>
    <Router>
      <Auth0ProviderWithHistory>
        <App />
      </Auth0ProviderWithHistory>
    </Router>
  </>,
  document.getElementById('root')
);

